import { render, staticRenderFns } from "./cameraVideo.vue?vue&type=template&id=6689ef5a&scoped=true&"
import script from "./cameraVideo.vue?vue&type=script&lang=js&"
export * from "./cameraVideo.vue?vue&type=script&lang=js&"
import style0 from "./cameraVideo.vue?vue&type=style&index=0&id=6689ef5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6689ef5a",
  null
  
)

export default component.exports